import { filter, map, pipe, prop, slice } from 'ramda';
import { useEffect, useState } from 'react';
import { GET_LIST, useDataProvider, useVersion } from 'react-admin';

const useDynamicContent = (contentId) => {
  const [dynamicContent, setDynamicContent] = useState();
  const version = useVersion();
  const dataProvider = useDataProvider();

  const fetchDynamicContent = async (table) => {
    const filters = {
      specificFields: [
        'id',
        'sourceTable',
        'campaignName',
        'branches',
        'creatingUid',
        'desktopImageUrl',
        'mobileImageUrl',
        'startDate',
        'endDate',
        'header',
        'headerColor',
        'headerSize',
        'headerWeight',
        'location',
        'status',
        'subHeader',
        'subHeaderColor',
        'subHeaderSize',
        'subHeaderWeight',
        'text',
        'timer',
        'isLink',
        'updatedAt',
        'url',
        'color',
        'iconUrl'
      ]
    };

    const { data } = await dataProvider(GET_LIST, `DynamicContent${table}`, {
      filter: filters,
      sort: { field: 'updatedAt', order: 'DESC' },
      pagination: { page: 1, perPage: 2000 }
    });

    const mappedContent = pipe(
      map((content) => ({
        id: prop('originalId', content),
        nodeId: prop('id', content),
        sourceTable: prop('sourceTable', content),
        campaignName: prop('campaignName', content),
        startDate: prop('startDate', content),
        endDate: prop('endDate', content),
        status: prop('status', content),
        creatingUid: prop('creatingUid', content),
        location: prop('location', content),
        header: prop('header', content),
        headerColor: prop('headerColor', content),
        headerSize: prop('headerSize', content),
        headerWeight: prop('headerWeight', content),
        subHeader: prop('subHeader', content),
        subHeaderColor: prop('subHeaderColor', content),
        subHeaderSize: prop('subHeaderSize', content),
        subHeaderWeight: prop('subHeaderWeight', content),
        desktopImageUrl: prop('desktopImageUrl', content),
        mobileImageUrl: prop('mobileImageUrl', content),
        timer: prop('timer', content),
        isLink: prop('isLink', content),
        url: prop('url', content),
        branches: prop('branches', content),
        text: prop('text', content),
        color: prop('color', content),
        iconUrl: prop('iconUrl', content)
      })),
      filter(prop('id'))
    )(data);

    mappedContent.shift(); // remove the recently added record

    setDynamicContent([...mappedContent]);
  };

  useEffect(() => {
    if (!contentId) {
      console.error('useDynamicContent - missing dynamic content id!');
      setDynamicContent([]);
    } else if (contentId.startsWith('ad')) {
      setDynamicContent([]);
    } else {
      const table =
        contentId.charAt(0).toUpperCase() + contentId.slice(1).toLowerCase();

      fetchDynamicContent(table);
    }
  }, [version]);

  return {
    dynamicContent
  };
};

export default useDynamicContent;
